module.exports = __webpack_public_path__ + "img/remind-icon3.0d3eb042.png";